import axiosInstance from "./axios";
import { useQuery, useMutation } from "react-query";
import { useState, useCallback, useEffect } from "react";
import debounce from "lodash/debounce";
const fetchData = async (endPoint) => {
	const response = await axiosInstance.get(endPoint);
	return response.data;
};

const mutateData = async ({ endPoint, data }) => {
	const response = await axiosInstance.post(endPoint, data);
	return response.data;
};

export const useFetchData = (endPoint) => {
	return useQuery([endPoint], () => fetchData(endPoint));
};

export const useMutateData = ({ onSuccess, onError, debounceDelay = 1000 }) => {
	const [isTriggered, setIsTriggered] = useState(true);

	const mutation = useMutation(mutateData, {
		onSuccess: (data) => {
			if (onSuccess) onSuccess(data);
		},
		onError: (error) => {
			console.error("Mutation Error:", error);

			if (onError) onError(error);

			if (error?.response?.data?.message) {
				console.error(`Server Error: ${error.response.data.message}`);
			} else {
				console.error("Unknown error occurred.");
			}
		},
		onSettled: () => {
			setIsTriggered(false); // Reset the trigger after the mutation is settled
		},
	});

	const debouncedMutate = useCallback(
		debounce(async (data) => {
			try {
				if (mutation.isLoading) {
					console.log("Cancelling previous mutation");
					mutation.reset(); // Resets the mutation to cancel any ongoing request
				}

				console.log("Being called");
				// Attempt mutation and catch errors internally
				await mutation.mutateAsync(data);
			} catch (error) {
				console.error("Debounced mutation error:", error);
				// Optionally, handle any errors from debounced mutation
			}
		}, debounceDelay),
		[mutation]
	);

	const mutate = async (data) => {
		setIsTriggered(true);
		try {
			debouncedMutate(data);
		} catch (error) {
			console.error("Error triggering mutation:", error);
			// Optionally trigger an error callback for this stage if needed
			if (onError) onError(error);
		}
	};

	return {
		mutate,
		isLoading: mutation.isLoading,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
		isIdle: mutation.isIdle,
		isFetching: mutation.isFetching,
	};
};
